import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGrid from './components/HotGrid';
import EditorPick from './components/EditorPick';
import Features from './components/Features';
import Reviews from './components/Reviews';
import CTASection from './components/CTASection';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': '韩漫网',
  'url': 'http://kcptesw.com/',
  'description': '韩漫网是领先的韩国漫画在线阅读平台，提供3000+部韩国漫画免费阅读，涵盖恋爱浪漫、奇幻冒险、热血动作、都市剧情等全类型题材，每日同步更新热门韩漫。',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': {
      '@type': 'EntryPoint',
      'urlTemplate': 'http://kcptesw.com/category/{search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotGrid />
        <EditorPick />
        <Features />
        <Reviews />
        <CTASection />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageJsonLd) }} />
    </>
  );
}